import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

export function initTimelineSlider() {
    const sliderElements = document.querySelectorAll('.timeline-slider');
    
    if (!sliderElements.length) return;

    sliderElements.forEach((sliderElement) => {
        const section = sliderElement.closest('section');
        
        const timelineTree = section?.querySelector('.timeline-tree');
        if (timelineTree) {
            console.warn('Timeline slider and timeline tree cannot coexist in the same section');
            return;
        }
        
        const prevButton = section?.querySelector('.timeline-prev');
        const nextButton = section?.querySelector('.timeline-next');
        const yearButtons = section?.querySelectorAll('.timeline-year-btn');
        const slides = sliderElement.querySelectorAll('.swiper-slide');
        const yearsSliderElement = section?.querySelector('.timeline-years-slider');
        
        // Variable to hold years slider reference
        let yearsSwiper = null;

        // Function to update active year button
        function updateActiveYear(index) {
            if (yearButtons) {
                yearButtons.forEach((btn, i) => {
                    if (i === index) {
                        btn.classList.remove('text-black/48');
                        btn.classList.add('text-red');
                    } else {
                        btn.classList.remove('text-red');
                        btn.classList.add('text-black/48');
                    }
                });
            }
        }

        // Function to update active slide styling
        function updateActiveSlide(index) {
            if (slides) {
                slides.forEach((slide, i) => {
                    if (i === index) {
                        slide.classList.add('timeline-slide-active');
                    } else {
                        slide.classList.remove('timeline-slide-active');
                    }
                });
            }
        }

        // Function to update navigation button opacity
        function updateNavigationOpacity(swiper) {
            if (prevButton) {
                if (swiper.isBeginning) {
                    prevButton.style.opacity = '0.5';
                    prevButton.style.pointerEvents = 'none';
                } else {
                    prevButton.style.opacity = '1';
                    prevButton.style.pointerEvents = 'auto';
                }
            }
            
            if (nextButton) {
                // More reliable check: if we're on the last slide index
                const isLastSlide = swiper.activeIndex >= swiper.slides.length - 1;
                if (isLastSlide) {
                    nextButton.style.opacity = '0.5';
                    nextButton.style.pointerEvents = 'none';
                } else {
                    nextButton.style.opacity = '1';
                    nextButton.style.pointerEvents = 'auto';
                }
            }
        }

        // Initialize main timeline slider
        const swiper = new Swiper(sliderElement, {
            modules: [Navigation],
            slidesPerView: 'auto',
            spaceBetween: 0,
            loop: false,
            initialSlide: 0,
            centeredSlides: false,
            speed: 600,
            navigation: {
                prevEl: prevButton,
                nextEl: nextButton,
            },
            breakpoints: {
                0: {
                    slidesOffsetBefore: 0,
                },
                768: {
                    slidesOffsetBefore: 0,
                }
            },
            on: {
                slideChange: function() {
                    updateActiveYear(this.activeIndex);
                    updateActiveSlide(this.activeIndex);
                    updateNavigationOpacity(this);
                    if (yearsSwiper) {
                        yearsSwiper.slideTo(this.activeIndex, 600);
                    }
                },
                reachEnd: function() {
                    updateNavigationOpacity(this);
                },
                fromEdge: function() {
                    updateNavigationOpacity(this);
                },
                init: function() {
                    // Add offset after to ensure last slide can scroll into view properly
                    const containerWidth = this.el.parentElement.offsetWidth;
                    const lastSlide = this.slides[this.slides.length - 1];
                    if (lastSlide) {
                        const lastSlideWidth = lastSlide.offsetWidth;
                        // Calculate offset needed to allow last slide to be active
                        const offsetAfter = containerWidth - lastSlideWidth - 16;
                        if (offsetAfter > 0) {
                            this.params.slidesOffsetAfter = offsetAfter;
                            this.update();
                        }
                    }
                    // Set initial navigation opacity
                    updateNavigationOpacity(this);
                },
                resize: function() {
                    // Recalculate offset after on resize
                    const containerWidth = this.el.parentElement.offsetWidth;
                    const lastSlide = this.slides[this.slides.length - 1];
                    if (lastSlide) {
                        const lastSlideWidth = lastSlide.offsetWidth;
                        const offsetAfter = containerWidth - lastSlideWidth - 16;
                        if (offsetAfter > 0) {
                            this.params.slidesOffsetAfter = offsetAfter;
                            this.update();
                        }
                    }
                    // Update navigation opacity after resize
                    updateNavigationOpacity(this);
                }
            },
        });

        // Initialize years slider (connected to main slider)
        if (yearsSliderElement) {
            yearsSwiper = new Swiper(yearsSliderElement, {
                slidesPerView: 'auto',
                spaceBetween: 20,
                loop: false,
                initialSlide: 0,
                centeredSlides: false,
                slideToClickedSlide: true,
                speed: 600,
                breakpoints: {
                    // Mobile breakpoint
                    0: {
                        spaceBetween: 10,
                        centeredSlides: false,
                    },
                    // Desktop breakpoint
                    768: {
                        spaceBetween: 20,
                        centeredSlides: true,
                    }
                },
                on: {
                    click: function(swiperInstance, event) {
                        const clickedSlide = event.target.closest('.swiper-slide');
                        if (clickedSlide) {
                            const index = Array.from(swiperInstance.slides).indexOf(clickedSlide);
                            if (index !== -1) {
                                swiperInstance.slideTo(index, 600);
                                swiper.slideTo(index, 600);
                                updateActiveYear(index);
                                updateActiveSlide(index);
                            }
                        }
                    },
                },
            });
        }

        // Year button click handlers
        if (yearButtons) {
            yearButtons.forEach((button, index) => {
                button.addEventListener('click', () => {
                    swiper.slideTo(index, 600);
                    updateActiveYear(index);
                    updateActiveSlide(index);
                    if (yearsSwiper) {
                        yearsSwiper.slideTo(index, 600);
                    }
                });
            });
        }

        // Make timeline slides clickable
        if (slides) {
            slides.forEach((slide, index) => {
                slide.style.cursor = 'pointer';
                slide.addEventListener('click', () => {
                    swiper.slideTo(index, 600);
                    updateActiveYear(index);
                    updateActiveSlide(index);
                    if (yearsSwiper) {
                        yearsSwiper.slideTo(index, 600);
                    }
                });
            });
        }

        // Set initial active state
        updateActiveYear(0);
        updateActiveSlide(0);
    });
}
